// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.style_container__I\\+oFu {
  width: 100%;
  position: relative;
  border: 1px solid var(--color-gray-700);
  border-radius: 8px;
  outline: none;
  display: flex;
  align-items: center;
  gap: 10px;
}
.style_container__I\\+oFu:focus-within {
  border: 1px solid var(--color-primary-500);
}
label + .style_container_input__HKLRG {
  padding-left: 38px;
}
.style_container_icon__ty4cS {
  position: absolute;
  margin-left: 10px;
  margin-right: 10px;
  top: 50%;
  color: var(--color-white-500);
  transform: translateY(-50%);
}
.style_container_input__HKLRG {
  background-color: var(--color-gray-700);
  border-radius: 8px;
  outline: none;
  border: none;
  width: 100%;
  height: 46px;
  padding: 0 10px;
  font-size: 16px;
  color: var(--color-white-500);
}
.style_container_input__HKLRG::placeholder {
  color: var(--color-white-500);
}
.style_container_input__HKLRG:disabled {
  background-color: var(--color-paper-700);
  border: 1px solid var(--color-gray-700);
  color: var(--color-gray-400);
  cursor: not-allowed;
}
.style_container_input_error_message__Mr2Bi {
  color: var(--error-color);
  font-size: 13px;
  margin-top: 7px;
  display: flex;
}
.style_container_reverse__3ZdVc {
  flex-direction: row-reverse;
  justify-content: space-between;
}
.style_container_reverse_icon__z2cwD {
  display: none;
  margin-right: 10px;
  margin-left: 0;
}
.style_container_dark__Cf--a {
  background-color: var(--color-gray-800);
  border: 1px solid var(--color-gray-700);
}
.style_container_error__tkTya {
  border: 1px solid var(--error-color);
}
.style_container_small__6rAQZ {
  height: 38px;
}
.style_container_small__6rAQZ input {
  font-size: 14px;
  height: 38px;
}
.style_container_tiny__FByxY {
  height: 32px;
}
.style_container_tiny__FByxY label + input {
  padding-left: 28px;
}
.style_container_tiny__FByxY input {
  height: 100%;
  font-size: 12px;
}
.style_container_tiny__FByxY label {
  margin-left: 7px !important;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-text-fill-color: var(--color-white-500) !important;
  -webkit-background-clip: text;
  -webkit-box-shadow: 0 0 0 30px var(--color-paper-400) inset !important;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/InputField/style.module.scss","webpack://./src/assets/scss/_colors.scss"],"names":[],"mappings":"AAEA;;EAEE,wBAAA;EACA,SAAA;AADF;;AAGA;EACE,0BAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EAEA,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AADF;AAEE;EACE,0CAAA;AAAJ;AAEE;EACE,kBAAA;AAAJ;AAEE;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,6BAAA;EACA,2BAAA;AAAJ;AAEE;EACE,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,6BAAA;AAAJ;AACI;EACE,6BAAA;AACN;AACI;EACE,wCAAA;EACA,uCAAA;EACA,4BAAA;EACA,mBAAA;AACN;AACI;EACE,yBClDQ;EDmDR,eAAA;EACA,eAAA;EACA,aAAA;AACN;AAEE;EACE,2BAAA;EACA,8BAAA;AAAJ;AACI;EACE,aAAA;EACA,kBAAA;EACA,cAAA;AACN;AAIE;EACE,uCAAA;EACA,uCAAA;AAFJ;AAIE;EACE,oCAAA;AAFJ;AAKE;EACE,YAAA;AAHJ;AAII;EACE,eAAA;EACA,YAAA;AAFN;AAKE;EACE,YAAA;AAHJ;AAII;EACE,kBAAA;AAFN;AAII;EACE,YAAA;EACA,eAAA;AAFN;AAII;EACE,2BAAA;AAFN;;AAOA;;;;EAOE,0DAAA;EAEA,6BAAA;EACA,sEAAA;AARF","sourcesContent":["@use \"/src/assets/scss/colors\" as *;\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.container {\n  width: 100%;\n  position: relative;\n  // background-color: var(--color-paper-400);\n  border: 1px solid var(--color-gray-700);\n  border-radius: 8px;\n  outline: none;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  &:focus-within {\n    border: 1px solid var(--color-primary-500);\n  }\n  label + &_input {\n    padding-left: 38px;\n  }\n  &_icon {\n    position: absolute;\n    margin-left: 10px;\n    margin-right: 10px;\n    top: 50%;\n    color: var(--color-white-500);\n    transform: translateY(-50%);\n  }\n  &_input {\n    background-color: var(--color-gray-700);\n    border-radius: 8px;\n    outline: none;\n    border: none;\n    width: 100%;\n    height: 46px;\n    padding: 0 10px;\n    font-size: 16px;\n    color: var(--color-white-500);\n    &::placeholder {\n      color: var(--color-white-500);\n    }\n    &:disabled {\n      background-color: var(--color-paper-700);\n      border: 1px solid var(--color-gray-700);\n      color: var(--color-gray-400);\n      cursor: not-allowed;\n    }\n    &_error_message {\n      color: $error-color;\n      font-size: 13px;\n      margin-top: 7px;\n      display: flex;\n    }\n  }\n  &_reverse {\n    flex-direction: row-reverse;\n    justify-content: space-between;\n    &_icon {\n      display: none;\n      margin-right: 10px;\n      margin-left: 0;\n    }\n  }\n\n  // ⭐ Variants\n  &_dark {\n    background-color: var(--color-gray-800);\n    border: 1px solid var(--color-gray-700);\n  }\n  &_error {\n    border: 1px solid $error-color;\n  }\n  // ⭐ Sizes\n  &_small {\n    height: 38px;\n    input {\n      font-size: 14px;\n      height: 38px;\n    }\n  }\n  &_tiny {\n    height: 32px;\n    label + input {\n      padding-left: 28px;\n    }\n    input {\n      height: 100%;\n      font-size: 12px;\n    }\n    label {\n      margin-left: 7px !important;\n    }\n  }\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  // font-size-adjust: none;\n  // -webkit-text-size-adjust: none;\n\n  -webkit-text-fill-color: var(--color-white-500) !important;\n\n  -webkit-background-clip: text;\n  -webkit-box-shadow: 0 0 0 30px var(--color-paper-400) inset !important;\n}\n","//Global colors\n$main-color: var(--main-color);\n$bg-color: var(--bg-color);\n$dark-bg: var(--dark-bg);\n$body-bg: var(--body-bg);\n$error-color: var(--error-color);\n\n$color-gradient-black-500: var(--color-gradient-black-500);\n$color-gradient-black-200: var(--color-gradient-black-200);\n\n//Gradient\n$gradient: var(--gradient);\n$gradient-border: var(--gradient-border);\n\n//text-colors\n$text-color-W: var(--text-color-W);\n\n//border\n$border: var(--border);\n\n//scrollbar\n$scrollbar-background: var(--scrollbar-background);\n$scrollbar-hover-color: var(--scrollbar-hover-color);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__I+oFu`,
	"container_input": `style_container_input__HKLRG`,
	"container_icon": `style_container_icon__ty4cS`,
	"container_input_error_message": `style_container_input_error_message__Mr2Bi`,
	"container_reverse": `style_container_reverse__3ZdVc`,
	"container_reverse_icon": `style_container_reverse_icon__z2cwD`,
	"container_dark": `style_container_dark__Cf--a`,
	"container_error": `style_container_error__tkTya`,
	"container_small": `style_container_small__6rAQZ`,
	"container_tiny": `style_container_tiny__FByxY`
};
export default ___CSS_LOADER_EXPORT___;
